export default __webpack_public_path__ + "static/media/Icon3.abe9bb2d.svg";